import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconSortLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.25 17.5a.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.535A.725.725 0 0 1 4.25 16h3.875c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534.726.726 0 0 1-.216.535.725.725 0 0 1-.534.215H4.25Zm0-4.75a.725.725 0 0 1-.534-.216A.726.726 0 0 1 3.5 12c0-.213.072-.391.216-.534a.725.725 0 0 1 .534-.216h9.683c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534.722.722 0 0 1-.216.534.725.725 0 0 1-.534.216H4.25Zm0-4.75a.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.535A.725.725 0 0 1 4.25 6.5h15.5c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534.726.726 0 0 1-.216.535.726.726 0 0 1-.534.215H4.25Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconSortLine;
